export default __webpack_public_path__ + "static/media/logo.a5017f3b.svg";